const apiHeaders = new Headers({
  'Content-Type': 'application/json',
  Accept: 'application/json',
  'X-Shopify-Storefront-Access-Token': window.storefrontApiToken,
})

export const makeRequest = (callback = null, query = {}, variables = {}) => {
  fetch(window.storefrontApiUrl, {
    method: 'POST',
    headers: apiHeaders,
    body: JSON.stringify({ query: query, variables: variables }),
  })
    .then((response) => response.json())
    .then((result) => {
      if (callback) callback(result)
    })
    .catch((e) => {
      console.error(e)
    })
}
